import React from 'react';
import PropTypes from 'prop-types';
import { t } from '@lingui/macro';
import { MessageDescriptor } from '@lingui/core';
import { I18n } from '@lingui/react';
import { RenderField } from '@oms/ui-field';
import { Select } from '@oms/ui-select';
// @ts-ignore
import {
  SELECTION_INTRADAY,
  SELECTION_ONE_MONTH,
  SELECTION_THREE_MONTHS,
  SELECTION_SIX_MONTHS,
  SELECTION_ONE_YEAR,
  SELECTION_THREE_YEARS,
  SELECTION_FIVE_YEARS,
} from '@oms/components-instrument-chart';

// Must be a class because react-select sets refs
// eslint-disable-next-line react/prefer-stateless-function
export const PeriodSelector = ({ onSelect, selection, id }: any) => {
  return (
    <I18n>
      {({ i18n }) => {
        /**
         * Select/Search/Combobox only accept strings as labels.
         * In order to convert them to strings we need access to the i18n object, which is only available
         * inside the return statement of the component.
         * @param message
         */
        const i18nToString = (message: MessageDescriptor): string =>
          i18n ? i18n._(message) : message.id;

        const periodOptions = [
          { value: SELECTION_INTRADAY, label: i18nToString(t`Intraday`) },
          { value: SELECTION_ONE_MONTH, label: i18nToString(t`1 month`) },
          // TODO fix so it works when switching to week
          // { value: SELECTION_WEEK, label: t`1 week` },
          { value: SELECTION_THREE_MONTHS, label: i18nToString(t`3 months`) },
          { value: SELECTION_SIX_MONTHS, label: i18nToString(t`6 months`) },
          { value: SELECTION_ONE_YEAR, label: i18nToString(t`1 year`) },
          { value: SELECTION_THREE_YEARS, label: i18nToString(t`3 years`) },
          { value: SELECTION_FIVE_YEARS, label: i18nToString(t`5 years`) },
        ];
        const value = periodOptions.find(
          (period) => period?.value === selection,
        );

        return (
          <RenderField
            as={Select}
            name="market"
            label={i18nToString(t`Period`)}
            items={periodOptions}
            value={value}
            onChange={onSelect}
          />
        );
      }}
    </I18n>
  );
};

PeriodSelector.propTypes = {
  selection: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  id: PropTypes.string,
};

export default PeriodSelector;
